import { Linking, Platform } from 'react-native'

import { useB2C } from '@zet/common/hooks/useB2C'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { Stack, XStack } from '@zet/design-system'
import { B18 } from '@zet/integration-flow/components/typography'

import { OtherCategorie } from '../../hooks/useBrandRecommendations'
import useFilterStore from '../../hooks/useFilterStore'
import useGetCategoryBanner from '../../hooks/useGetCategoryBanner'
import { parseCMSScreenOptions } from '../../utils'
import { REDIRECTION_LINK } from '../../utils/constants'
import FilterBar from './filterBar'

type JFSFiltersProps = {
  categoryId: number
  customerId?: number
  isRecommendationFlow: boolean
  isBMSFlow: boolean
  isJfsFlow: boolean
  otherCategories?: Array<OtherCategorie>
  isCategoryInEligible?: boolean
  selectedCategory: {
    categoryId: string | number
    categoryName: string
    totalCount: number
  }
}

const JFSFilters = ({
  isCategoryInEligible,
  categoryId,
  customerId,
  isRecommendationFlow,
  otherCategories,
  selectedCategory,
  isBMSFlow,
  isJfsFlow,
}: JFSFiltersProps) => {
  const setCategoryId = useFilterStore((state) => state?.setCategoryId)
  const { data } = useGetCategoryBanner({ categoryId })
  const { navigate } = useNavigation()

  const topStrap = data?.media_for_the_banner?.image?.url
  const screenName = data?.media_for_the_banner?.redirect_to_screen
  const options = data?.media_for_the_banner?.screenOptions

  const isWeb = Platform.OS === 'web'

  const { isB2C, b2cRewardType } = useB2C()

  const handleBannerClick = () => {
    if (screenName) {
      if (screenName === REDIRECTION_LINK) {
        Linking.openURL(options?.url)
      } else {
        navigate(screenName, parseCMSScreenOptions(options))
      }
    }
  }

  return (
    <Stack>
      <XStack className="pl-3 items-center justify-between bg-white py-2">
        <B18>{'Eligible cards'}</B18>
        <FilterBar
          categoryId={categoryId}
          customerId={customerId}
          isBMSFlow={isBMSFlow}
          isJfsFlow={isJfsFlow}
        />
      </XStack>
    </Stack>
  )
}

export default JFSFilters
